import React from "react";
import {withApollo} from "react-apollo";
import { getUserQuery, userData } from "../graph";
import ErrorModal from "../../etc/modals/Error"
import { Link } from "react-router-dom";


import ChevronLeft from "@material-ui/icons/ChevronLeft";
import EditIcon from "@material-ui/icons/Edit";
import SaveIcon from "@material-ui/icons/Save";
import GridContainer from "components/Grid/GridContainer";
import ItemGrid from "components/Grid/ItemGrid";
import IconCard from "components/Cards/IconCard.jsx";

import Button from "components/CustomButtons/Button.jsx";
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

const styles = theme => ({
    button: {
        margin: theme.spacing.unit,
        fontSize: 20,
    },
    leftIcon: {
        marginRight: theme.spacing.unit,
    },
    rightIcon: {
        marginLeft: theme.spacing.unit,
    },
    iconSmall: {
        fontSize: 20,
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2,
    },
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    }
});


class UpdateUser extends React.Component {
    constructor(props){
        super(props)
        this.state = { 
            uid: null,
            username: null
        }
        this.onChangeHandler = this.onChangeHandler.bind(this)
        this.onSubmitHandler = this.onSubmitHandler.bind(this)
    }

    componentDidMount(){
        this.props.client.query({
            query: getUserQuery, 
            variables: { uid: this.props.match.params.uid }
        }).then((results) => {
            this.setState({
                uid: results.data.user.uid,
                username: results.data.user.username
            })
        })
    }

    onChangeHandler(event){
        event.preventDefault()
        const target = event.target;
        let value = target.value
        this.setState({
            [target.name]: value
        });
    }

    onSubmitHandler(event){
        event.preventDefault();
        let _this = this;
        this.props.updateUser({
            variables:{
                uid: _this.state.uid,
                username: _this.state.username
            }
        })
        .then( this.props.history.push("/users/" + _this.state.uid) )
        .catch(({errors}) => {
            <ErrorModal />
        });
    }


     render(){
        let classes = this.props.classes;
        let actions = (this.state.username != null ) ?
                            <GridContainer>
                                <ItemGrid xs={12}>
                                    <Link to={"/users/"}  size='sm'>
                                        <Button variant="flat" className={classes.button} size='sm' style={{flex: 1}}>
                                            <ChevronLeft size='sm'/> Cancel
                                        </Button>
                                    </Link>
                                    <Link onClick={ this.onSubmitHandler } to='' size='sm'>
                                        <Button variant="flat" className={classes.button} size='sm' style={{flex: 1}}>
                                            <SaveIcon size='sm' /> Save
                                        </Button>
                                    </Link>
                                </ItemGrid>
                            </GridContainer>
                        : null;

        let update_form = (this.state.username != null) ?
                                <form className={classes.root}>
                                    <ItemGrid xs={6} md={8} lg={4}>
                                        <TextField
                                              id="username"
                                              label="Username"
                                              InputLabelProps={{
                                                shrink: true,
                                              }}
                                              margin="normal"
                                              InputProps={{
                                                    value: (this.state.username),
                                                    onChange: this.onChangeHandler, 
                                                    name: 'username'
                                                }}
                                        />
                                    </ItemGrid>
                                </form>
                            : null;

        return(
            <GridContainer>
                <ItemGrid xs={9} style={{marginLeft: '17px'}}>
                    <IconCard
                        icon={ EditIcon }
                        title="User"
                        content={ update_form }
                        footer={actions}
                    />
                </ItemGrid>
            </GridContainer>
        )
    }
}

export default withStyles(styles)((userData)(withApollo(UpdateUser)))


// WEBPACK FOOTER //
// ./src/views/users/components/Update.js